import list from "./list"
import detail from './detail'

export default {
    list: list,
    detail: detail, 
    name: "employeesalaries",
    key: "p_employeesalaries",
}